<template>
	<div class="affairs-section-wrapper relative">
		<vx-card class="no-scroll-content">
			<div class="affairs-section">
				<div class="affairs-section-header">
					<h1>{{ $t('scheduledTasks') }}</h1>
				</div>
				<div class="affairs-section-body">
					<div class="affairs-left-panel">

						<vs-button
							icon-pack="feather"
							class="add-affair-btn w-full"
							@click="$emit('addTask',{date:new Date()})"
						>{{ $t('addTask') }}</vs-button>

						<vs-custom-button
							color="primary"
							type="border"
							class="filter-button"
							@click="setFilterState('all')"
						>{{ $t('all') }}</vs-custom-button>

						<vs-custom-button
							color="primary"
							type="border"
							class="filter-button"
							@click="setFilterState('current')"
						>{{ $t('notDone(many)') }}</vs-custom-button>

						<vs-custom-button
							color="primary"
							type="border"
							class="filter-button"
							@click="setFilterState('byNow')"
						>{{ $t('forThisDay') }}</vs-custom-button>
						<vs-custom-button
							v-if="userRole === 'manager' || userRole === 'admin'"
							color="primary"
							type="border"
							class="filter-button"
							@click="setFilterState('support')"
						>{{ $t('support') }}</vs-custom-button>
						<vs-custom-button
							v-if="userRole === 'manager' || userRole === 'admin'"
							color="primary"
							type="border"
							class="filter-button"
							@click="setFilterState('sales')"
						>{{ $t('sales') }}</vs-custom-button>
						<vs-custom-button
							v-if="userRole === 'admin'"
							color="primary"
							type="border"
							class="filter-button"
							@click="setFilterState('payments')"
						>{{ $t('payments') }}</vs-custom-button>

					</div>

					<div class="affairs-list">
						<div class="filter-status">
							<h5>{{ $t('sort') }}: <b>{{ getFilterTitle }}</b></h5>
						</div>
						<div class="affairs-right-panel">
							<AffairsList
								:taskList="taskList"
								:filter="filter"
								@editTask="onEditTask($event)"
								@assignToManager="onAssignToManager"
                @openCommentsChat="openCommentsChat"
                @load-events="loadEvents"
							></AffairsList>
						</div>
					</div>

          <transition name="fade" mode="out-in">
            <div v-if="openedAffairsChat" class="affairs-comments-chat">
              <AffairItemCommentChat
                :group-item="affairsGroupItem"
                @closeChat="closeAffairsChat"
              />
            </div>
          </transition>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
import VxCard from '@/components/vx-card/VxCard'
import AffairsList from '@/components/affairs/AffairsList'
import VsCustomButton from "@/components/vs-custom-button/VsCustomButton";
import AffairItemCommentChat from '@/components/affairs/affair-item-comment-chat/AffairItemCommentChat.vue'

export default {
	name: 'AffairsSection',
	components: {
    VsCustomButton,
    VxCard,
    AffairsList,
    AffairItemCommentChat,
},
	props: {
		taskList: {
			type: Array,
			default: () => []
		},
    filter: {
      type: String,
      default: 'all',
    },
	},
	data () {
		return {
			filters: [
				{ name: this.$t('all'), value: 'all' },
				{ name: this.$t('notDone(many)'), value: 'current' },
				{ name: this.$t('forThisDay'), value: 'byNow' },
			],
      openedAffairsChat: false,
      affairsGroupItem: null,
		}
	},

	computed: {
		getFilterTitle() {
		  const obj = this.filters.find((el) => el.value === this.filter)
		  if (!obj) {
			return ''
		  }

      	return obj.name
		},

		userRole() {
			return this.$store.state.auth.role;
		},
	},

	methods: {
    setFilterState(value) {
      if (this.filter === value) {
        return
      }

      this.$emit('change-filter', value)
    },

    loadEvents(callback) {
      this.$emit('load-events', callback)
    },

		onEditTask(e){
			this.$emit('editTask',e)
		},

		onAssignToManager(e){
			this.$emit('assignToManager',e)
		},

    openCommentsChat(groupItem) {
      this.openedAffairsChat = false
      this.affairsGroupItem = groupItem
      this.openedAffairsChat = true
    },

    closeAffairsChat() {
      this.openedAffairsChat = false
      this.affairsGroupItem = null
    }
	},

	mounted() {
    this.setFilterState(this.filters[0].value)
	}
}
</script>

<style lang="scss" scoped>
.affairs-section-wrapper {
	width: 40%;

	@media screen and (max-width: 1500px) {
		flex: 100% 0 0;
	}

	.vx-card {
		overflow: hidden;
		min-height: 600px;

		::v-deep .vx-card__collapsible-content.vs-con-loading__container {
			height: 100%;
			overflow: hidden;

			.vx-card__body {
				height: 100%;
			}
		}
	}

	.affairs-section {
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow: hidden;

		.affairs-list {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
      min-height: 0;
		}
	}

	.affairs-section-header {
		padding-bottom: 1.5rem;
	}

	.affairs-section-body {
		display: flex;
		height: 100%;
		overflow: hidden;


    @media screen and (max-width: 580px) {
      flex-direction: column;
      grid-row-gap: 10px;
    }

		.affairs-left-panel {
			flex: 182px 0 1;
			padding-right: 1rem;
			border-right: 1px solid #eee;

			@media screen and (max-width: 580px) {
				flex: 130px 0 1;
			}

			.left-panel-filter {
				margin-top: 1rem;
			}
		}

		.affairs-right-panel {
			// flex: 100px 1 1;
			// overflow: auto;
      display: flex;
      height: 100%;
      min-height: 0;
		}
	}

	.filter-status {
		margin-left: 10px;
		padding-bottom: 14px
	}

	.filter-button {
		width: 100%;
		margin-top: 13px;
	}

	.add-affair-btn {
		margin-bottom: 13px;
	}

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
    z-index: 1000000;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
